import React from "react";
import {
  Sparkles,
  Rocket,
  Megaphone,
  Smile,
  Wrench,
  Flower2,
  Sofa,
  GraduationCap,
  Cake,
  Building2,
  HeartPulse,
  Scale,
} from "lucide-react";

// Each tag has a Lucide icon + a color tone. Tones map to a light tint bg + a
// saturated icon color, so the marquee reads as colorful yet on-brand.
const TAGS = [
  { label: "D2C skincare", icon: Sparkles, tone: "rose" },
  { label: "SaaS founders", icon: Rocket, tone: "green" },
  { label: "Digital marketing agency", icon: Megaphone, tone: "orange" },
  { label: "Local dental clinics", icon: Smile, tone: "teal" },
  { label: "Home services", icon: Wrench, tone: "amber" },
  { label: "Yoga studios", icon: Flower2, tone: "purple" },
  { label: "Interior designers", icon: Sofa, tone: "brown" },
  { label: "Ed-tech creators", icon: GraduationCap, tone: "blue" },
  { label: "Boutique bakeries", icon: Cake, tone: "pink" },
  { label: "Real-estate brokers", icon: Building2, tone: "indigo" },
  { label: "Wellness coaches", icon: HeartPulse, tone: "red" },
  { label: "Legal consultants", icon: Scale, tone: "slate" },
];

const TONE = {
  rose:   { bg: "bg-rose-100",    fg: "text-rose-600" },
  green:  { bg: "bg-emerald-100", fg: "text-emerald-700" },
  orange: { bg: "bg-orange-100",  fg: "text-orange-600" },
  teal:   { bg: "bg-teal-100",    fg: "text-teal-700" },
  amber:  { bg: "bg-amber-100",   fg: "text-amber-700" },
  purple: { bg: "bg-purple-100",  fg: "text-purple-600" },
  brown:  { bg: "bg-yellow-100",  fg: "text-yellow-800" },
  blue:   { bg: "bg-sky-100",     fg: "text-sky-700" },
  pink:   { bg: "bg-pink-100",    fg: "text-pink-600" },
  indigo: { bg: "bg-indigo-100",  fg: "text-indigo-700" },
  red:    { bg: "bg-red-100",     fg: "text-red-600" },
  slate:  { bg: "bg-slate-200",   fg: "text-slate-700" },
};

export default function TrustBar() {
  const items = [...TAGS, ...TAGS]; // doubled for seamless marquee
  return (
    <section className="border-y-0 bg-transparent">
      <div className="w-full py-8 md:py-10">
        <div className="px-5 md:px-10 mb-5 flex flex-col md:flex-row md:items-baseline md:justify-between gap-2">
          <p className="text-sm text-lm-text2">
            Built for the founders under-served by enterprise sales tools -
          </p>
          <p className="text-xs font-mono uppercase tracking-widest text-lm-secondary">
            Made for these founder types
          </p>
        </div>
        <div className="relative overflow-hidden mask-fade-x">
          <div className="lm-marquee lm-marquee-slow gap-3 px-5">
            {items.map((tag, i) => {
              const t = TONE[tag.tone] || TONE.green;
              const Icon = tag.icon;
              return (
                <span
                  key={i}
                  className="inline-flex items-center gap-3 pl-2.5 pr-5 py-2.5 rounded-full border border-lm-border bg-lm-surface text-lm-text whitespace-nowrap text-base font-medium shadow-[0_1px_0_rgba(31,74,56,0.04)]"
                >
                  <span
                    className={`inline-flex items-center justify-center w-9 h-9 rounded-full ${t.bg} ${t.fg}`}
                  >
                    <Icon className="w-5 h-5" strokeWidth={2.1} />
                  </span>
                  {tag.label}
                </span>
              );
            })}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-lm-bg to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-lm-bg to-transparent" />
        </div>
      </div>
    </section>
  );
}
